
import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import {AsyncPipe, NgIf} from '@angular/common';
import { LoaderService } from '../../core/services/loader.service';

@Component({
  selector: 'app-loader-overlay',
  standalone: true,
  imports: [NgIf, AsyncPipe],
  template: `
    <div class="app-loading-overlay" *ngIf="visible$ | async" aria-live="polite" aria-busy="true">
      <div class="app-loading-backdrop"></div>
      <div class="app-loading-content">
        <!-- If using Bootstrap: -->
        <div class="spinner-border text-light" role="status" aria-label="Loading"></div>
        <div class="mt-3 text-light fw-semibold">Loading, please wait…</div>

        <!-- If not using Bootstrap, swap to a custom spinner (see CSS below)
        <div class="app-css-spinner" role="status" aria-label="Loading"></div>
        <div class="mt-3 text-light fw-semibold">Loading, please wait…</div>
        -->
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderOverlayComponent {
  private loader = inject(LoaderService);
  visible$ = this.loader.visible$;
}
